import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { SIGN_IN_INSTEAD, SignupErrorCode, errorKey } from '../../../modules/signup/signup-errors';

/** One failure, in plain words; "you already have an account" comes with the way in. */
export const SignupError = ({ code, email }: { code: SignupErrorCode; email?: string }) => {
    const { t } = useTranslation();
    return (
        <p role="alert" className="mt-3 text-sm leading-relaxed text-destructive" data-testid={`signup-error-${code}`}>
            {t(errorKey(code))}
            {SIGN_IN_INSTEAD.includes(code) && (
                <>
                    {' '}
                    <Link to="/login" state={email ? { email } : undefined} className="font-medium text-foreground underline-offset-4 hover:underline">
                        {t('SIGNUP.SIGN_IN_INSTEAD')}
                    </Link>
                </>
            )}
        </p>
    );
};
